import { Livewire, Alpine } from "../../vendor/livewire/livewire/dist/livewire.esm";
import "../../vendor/wire-elements/modal/resources/js/modal";
import focus from "@alpinejs/focus";
import Clipboard from "@ryangjchandler/alpine-clipboard";
import CopyToClipboard from "./components/CopyToClipboard";
import DropzoneUploader from "./components/DropzoneUploader";
import UppyUploader from "./components/UppyUploader";
import "./sortable";

// import static assets for versioning
import.meta.glob('../images/**')

Alpine.data('CopyToClipboard', CopyToClipboard)
Alpine.data('dropzoneUploader', DropzoneUploader)
Alpine.data('uppyUploader', UppyUploader)
Alpine.plugin(focus)
Alpine.plugin(Clipboard)

Alpine.magic('localTime', () => (isoString) => {
    return new Intl.DateTimeFormat(undefined, {
        day: 'numeric', month: 'short', year: 'numeric',
        hour: '2-digit', minute: '2-digit',
    }).format(new Date(isoString));
});

Livewire.start()
